<div class="form-group my-3">
  <label class="text-center fs-4 d-block">¿Cómo calificas el proceso de apertura?</label>
  <div class="star-rating mt-2">
    @for (star of stars; track $index; let i = $index) {
      <button
        (click)="selectRating(i + 1)"
        [class.active]="i < selectedRating"
        class="btn star-btn"
        type="button">
        ★
      </button>
    }
  </div>
</div>
<button (click)="rateClaim()" class="btn btn-danger bg-colonial d-block m-auto" type="button">Calificar</button>
